export default [
    {
        path: '/integration-hours',
        name: 'integration-hours',
        component: () => import ('./pages/Index'),
        meta: {
            title: 'Integração Horários',
            icon: 'mdi-clock-digital',
            breadcrumbs: [
                { text: 'Horários', disabled: true }
            ]
        }
    }
]